document.addEventListener('DOMContentLoaded', function() {
  // 1. We find each piece we need by name or ID or class.
  var storeHoursLocation = document.getElementById('store-hours-location');
  var sidebar            = document.getElementById('halo-store-hours-sidebar');
  var overlay            = document.getElementById('halo-store-hours-overlay');
  var closeButton        = document.getElementById('halo-store-hours-close');

  // NEW LINE: Instead of using <body>, we grab the element with class "body-content-wrapper"
  var bodyWrapper        = document.querySelector('.body-content-wrapper');

  // 2. Check if everything exists
  if (
    !storeHoursLocation ||
    !sidebar ||
    !overlay ||
    !closeButton ||
    !bodyWrapper
  ) {
    return;
  }

  storeHoursLocation.setAttribute('role', 'button');
  storeHoursLocation.setAttribute('tabindex', '0');
  storeHoursLocation.setAttribute('aria-controls', sidebar.id);
  storeHoursLocation.setAttribute('aria-expanded', 'false');
  sidebar.setAttribute('role', 'dialog');
  sidebar.setAttribute('aria-modal', 'true');
  sidebar.setAttribute('aria-label', sidebar.querySelector('h2').textContent);
  sidebar.inert = true;
  var opener;

  // 3. This function opens the sidebar and the overlay
  function openStoreHours() {
    opener = document.activeElement;
    sidebar.inert = false;
    storeHoursLocation.setAttribute('aria-expanded', 'true');
    sidebar.classList.add('open');
    overlay.classList.add('open');

    // NEW LINE: Lock the background by adding a class to bodyWrapper
    bodyWrapper.classList.add('halo-body-no-scroll');
    closeButton.focus();
  }

  // 4. This function closes the sidebar and overlay
  function closeStoreHours() {
    sidebar.classList.remove('open');
    sidebar.inert = true;
    storeHoursLocation.setAttribute('aria-expanded', 'false');
    overlay.classList.remove('open');

    // NEW LINE: Unlock the background by removing that class
    bodyWrapper.classList.remove('halo-body-no-scroll');
    if (opener && opener.isConnected) opener.focus();
  }

  // 5. When you click the #store-hours-location DIV, open the sidebar
  storeHoursLocation.addEventListener('click', function(e) {
    e.preventDefault();
    openStoreHours();
  });

  // 6. When you click the Close button, close the sidebar
  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
    closeStoreHours();
  });

  // 7. When you click the overlay background, also close
  overlay.addEventListener('click', closeStoreHours);
  storeHoursLocation.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openStoreHours(); }
  });
  document.addEventListener('keydown', function(e) {
    if (!sidebar.classList.contains('open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeStoreHours(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.from(sidebar.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(function(el) {
      return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length;
    });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || !sidebar.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !sidebar.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
});
